import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Global } from '@services/core/Global';
import { StorageService } from '@services/core/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AccountSalaryRefService {
  private url: string;
  public urlEmployeeType:string;
  public token;
  private storageService = inject(StorageService)
  
  constructor(
    private _http: HttpClient

  ) { 
     this.url = Global.url_app;
     this.token = this.storageService.getJsonValue("token") 
     this.urlEmployeeType = 'assets/data/type-employee.json';
    }


/** */    
protected convertToFilter(objeto): HttpParams {
  let params = new HttpParams(); 
  const hasKeys = Object.keys(objeto)?.length > 0;
  if (hasKeys!=null||hasKeys!=undefined) {
      params = this.createKeys(objeto, params);
  }   
  return params; 
}

protected createKeys(objeto, params) {
  for (const clave in objeto) {
      if (objeto[clave]!=null||objeto[clave]!=undefined) {
          params = params.append(clave, objeto[clave]);
      }
  }
  return params; 
}

  /**crea la url pasandole los parametros ej. {id:1,rut:15} reuturn '1/15 */
  buildUrl(params) {
    let queryParams = '';
    if (params) {
      queryParams = Object.keys(params)
        .map((key) => `${params[key]}`)
        .join('/');
    }
    return queryParams ? `${queryParams}` : '';
  }



/**account_plan_version_field_config */

getAccountSalaryRef(): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let result=this._http.get(this.url+'account-salary-ref/', { headers: headers });
 return result
}

updateAccountSalaryRef(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"account-salary-ref/"+params.id, params,{ headers: headers })
}


saveAccountSalaryRef(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"account-salary-ref",body, { headers: headers})
}

deleteAccountSalaryRef(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"account-salary-ref/"+params.id,{ headers: headers })
}

getEmployeeType(): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.get(this.url+"employee-type", { headers: headers})
}

updateAccountSalaryRefBulk(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"account-salary-ref-bulk", params,{ headers: headers })
}


}
